<div class="modal-body width-500">
  <div class="layout-auto-1-auto">

    <h5 class="modal-header">{{getRessource("ChangePasswordHeader")}}</h5>

    <div class="login content">

        <div class="md-input">
          <input type="password" name="oldPwd" autocomplete="off" autofocus
                 [(ngModel)]="oldPwd">
          <label>{{getRessource("OldPassword")}}</label>
        </div>
        <div class="md-input">
          <input type="password" name="pwd" autocomplete="off"
                 [(ngModel)]="pwd.Value">
          <label>{{getRessource("NewPassword")}}</label>
        </div>
        <div class="md-input">
          <input type="password" name="pwdRepeat" autocomplete="off"
                 [(ngModel)]="pwdRepeat.Value">
          <label>{{getRessource("NewPasswordRepeat")}}</label>
        </div>
        <div  style="padding: 0.5rem"  class="typo-small">
          <ul style="padding-bottom: 1em;">
            <!--<ul>-->
            <li class="ch-text" [ngStyle]="{'color':(!m.isValid)? 'var(--c-red-400)':'var(--c-green-400)'}" style="list-style: none;"
                *ngFor="let m of pwd.Messages">
              <i class="fal fa-fw fa-times" [ngClass]="{'fa-times':!m.isValid,'fa-check':m.isValid}"></i><span
              class="ng-binding"> {{m.message}}</span>
              <ul style="margin-left:1rem">
                <li class="ch-text" [ngStyle]="{'color':(!sm.isValid && !m.isValid)? 'var(--c-red-400)':'var(--c-green-400)'}"
                    style="list-style: none"
                    *ngFor="let sm of m.messages" [value]="sm.message">
                  <i class="fal fa-fw fa-times" [ngClass]="{'fa-times':!sm.isValid,'fa-check':sm.isValid}"></i>
                  <span class="ng-binding"> {{sm.message}}</span>
                </li>
              </ul>
            </li>
          </ul>
          <div [hidden]="!excSecurityService.CurrentUser?.faPwdChange">{{getRessource("ForcePasswordChangeMessage")}}</div>

        </div>
    </div>
    <div class="spawn-modal-actions">

      <button class="md-btn" [hidden]="excSecurityService.CurrentUser?.faPwdChange" (click)="close()">{{getGlobal(
        "Cancel")}}</button>
      <button class="md-btn"
              (click)="changePassword()">{{getRessource(
        "ChangePasswordOkButton")}}</button>

    </div>
  </div>
</div>
